module.exports = __webpack_public_path__ + "857997d751d9878c7b7fa7b8ae79945d.png";